import egypt from './header/egypt.png';
import usa from './header/united-states.png';

export class Components {
  header = {
    egypt,
    usa,
  };
}
